import React from 'react';
import { CheckIcon, FlameIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-teal-700/40 bg-zinc-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-62" data-mp="15ddija1lhxjj">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-63" data-mp="1jcljo8hbjfqd">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-64" data-mp="1jb228ejxeyn0">
          <span className="inline-flex items-center gap-2" data-id="element-65" data-mp="1t2omf0e8s81w">
            <FlameIcon className="h-8 w-8 shrink-0 text-orange-400 drop-shadow-[0_0_6px_rgba(251,146,60,0.55)]" aria-hidden="true" data-id="element-66" data-mp="1t252je5179l8" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-orange-400 sm:text-2xl" data-id="element-67" data-mp="222uyqiy7f1zh">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-zinc-300" data-id="element-68" data-mp="n5ul3zmwvjfp">
          Created for boiler room, plant utility and maintenance professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-69" data-mp="x3s5ud5kay3k">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-zinc-300" data-id="element-70" data-mp="120scoqa8k4vq">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-71" data-mp="1b39xr1e5mrh5">
              <CheckIcon className="h-4 w-4 text-teal-400 drop-shadow-[0_0_6px_rgba(45,212,191,0.55)]" aria-hidden="true" data-id="element-72" data-mp="1b171w0qbm44i" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}